import React, { useEffect } from "react";
import { Button, Modal, Form, Input, message, DatePicker } from "antd";
import API from "../../../../services/api-request";
import dayjs from "dayjs";
import SelectProductType from "../../../../components/SelectProductType";

const EditProductCost = (props) => {
  const [editForm] = Form.useForm();

  const onFinish = async (values) => {
    const { first_week_fee, daily_fee, product_type_id, efective_date } =
      values;

    const dataForm = {
      first_week_fee,
      daily_fee,
      product_type_id,
      efective_date: dayjs(efective_date).format("YYYY-MM-DD"),
    };

    await API.Put(`storage-cost/${props.selectedData.id}`, dataForm)
      .then(() => {
        message.success("Product has been edited");
        props.onGetProductCost();
        editForm.resetFields();
        props.onShowEdit(false);
      })
      .catch((err) => {
        console.log(err);
        message.info(`${err?.response?.data?.error}`);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowEdit(false);
    editForm.resetFields();
  };

  useEffect(() => {
    editForm.setFieldsValue({
      ...props.selectedData,
      efective_date: dayjs(props.selectedData.efective_date),
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedData]);

  useEffect(() => {
    if (!props.showEdit) {
      editForm.resetFields();
    }
  }, [props.showEdit]);

  return (
    <>
      <Modal
        title="Edit Product Cost"
        open={props.showEdit}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => editForm.submit()}>
            Save
          </Button>,
        ]}
      >
        <Form
          form={editForm}
          name="Edit Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Product Type"
            name="product_type_id"
            rules={[{ required: true, message: "Please input Product Type!" }]}
          >
            <SelectProductType />
          </Form.Item>
          <Form.Item
            label="Harga Minggu Pertama"
            name="first_week_fee"
            rules={[
              { required: true, message: "Please input Harga Minggu Pertama!" },
            ]}
          >
            <Input placeholder="Input Harga Minggu Pertama" />
          </Form.Item>
          <Form.Item
            label="Harga Harian"
            name="daily_fee"
            rules={[{ required: true, message: "Please input Harga Harian!" }]}
          >
            <Input placeholder="Input Harga Harian" />
          </Form.Item>
          <Form.Item
            label="Tanggal Efektif Date"
            name="efective_date"
            rules={[
              { required: true, message: "Please input Tanggal Efektif Date!" },
            ]}
          >
            <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default EditProductCost;
